import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/'
import PagesService from '@/services/Pages'

import Auth from '@/services/Auth'
import LoginView from '@/views/Login'
import NotFoundView from '@/views/NotFound'
import DashView from '@/views/Dash'
import HomeView from '@/views/dash/Home'
import PortalDocumentos from '@/views/dash/Documentos'
import PortalManual from '@/views/dash/Manual'
import PortalForum from '@/views/dash/Forum'
import PortalStatus from '@/views/dash/Status'
import PortalStatusPublic from '@/views/dash/StatusPublic'
import PortalComunicados from '@/views/dash/Comunicados'
import PortalFAQ from '@/views/dash/FAQ'
import PortalOpcaoPlanta from '@/views/dash/OpcaoPlanta'
import PortalGuiaFinanceiro from '@/views/dash/GuiaFinanceiro'
import PortalGuiaCliente from '@/views/dash/GuiaCliente'
import PortalSituacaoFinanceira from '@/views/dash/SituacaoFinanceira'
import PortalIRPF from '@/views/dash/IRPF'
import PortalEnvioMensagem from '@/views/dash/EnvioMensagem'
import PortalDecorado from '@/views/dash/Decorado'
import PortalFichaTecnica from '@/views/dash/FichaTecnica'
import PortalCadastro from '@/views/dash/Cadastro'
import PortalTrocaSenha from '@/views/dash/TrocaSenha'
import PrivacyPolicy from '@/views/dash/PrivacyPolicy'
// import TermosLGPD from '@/views/TermoLGPD'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  hashbang: false,
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),

  routes: [
    {
      path: '/login',
      name: 'Login',
      component: LoginView,
      meta: {
        title: 'Login'
      }
    },
    {
      path: '/status/:id',
      name: 'Status',
      component: PortalStatusPublic,
      meta: {
        title: 'Status'
      }
    },
    // {
    //   path: '/termos-lgpd',
    //   name: 'Termos LGPD',
    //   component: TermosLGPD,
    //   meta: {
    //     title: 'Termos LGPD'
    //   }
    // },
    {
      path: '/',
      component: DashView,
      meta: { auth: true },
      children: [
        { path: '', component: HomeView, meta: { title: 'Home' } },

        { path: 'documentos', component: PortalDocumentos, meta: { title: 'Documentos' } },
        { path: 'manual', component: PortalManual, meta: { title: 'Manual do proprietário' } },
        { path: 'status', component: PortalStatus, meta: { title: 'Status de obra' } },
        { path: 'forum', component: PortalForum, meta: { title: 'Fórum de afetação' } },
        { path: 'comunicados', component: PortalComunicados, meta: { title: 'Comunicados' } },
        { path: 'perguntas-frequentes', component: PortalFAQ, meta: { title: 'Perguntas Frequentes' } },
        { path: 'opcao-planta', component: PortalOpcaoPlanta, meta: { title: 'Personalização' } },
        { path: 'guia-financeiro', component: PortalGuiaFinanceiro, meta: { title: 'Guia Financeiro' } },
        { path: 'guia-do-cliente', component: PortalGuiaCliente, meta: { title: 'Guia do Cliente' } },

        { path: 'situacao-financeira', component: PortalSituacaoFinanceira, meta: { title: 'Situação Financeira' } },
        { path: 'informe-ir', component: PortalIRPF, meta: { title: 'Informe IR' } },

        { path: 'envio-mensagem', component: PortalEnvioMensagem, meta: { title: 'Envio de mensagem' } },
        { path: 'decorado', component: PortalDecorado, meta: { title: 'Apartamento Decorado' } },
        { path: 'ficha-tecnica', component: PortalFichaTecnica, meta: { title: 'Ficha Técnica' } },
        { path: 'seus-dados', component: PortalCadastro, meta: { title: 'Seus dados' } },
        { path: 'troca-senha', component: PortalTrocaSenha, meta: { title: 'Troca de senha' } },
        { path: 'politica-privacidade', component: PrivacyPolicy, meta: { title: 'Política de Privacidade' } }
      ]
    }, {
      path: '*',
      component: NotFoundView
    }
  ]
})

Vue.http.interceptors.push(function (request, next) {
  next(function (response) {
    switch (response.status) {
      case 200:
      case 201:
      case 204:
        const jwt = (localStorage.getItem('STORAGE.TOKEN') || '')
        request.headers['Authorization'] = jwt

        break

      case 401:
        Auth.logout()
        break

      case 404:
        console.debug('404!')
        break
    }
  })
})

router.beforeEach((to, from, next) => {
  document.title = (to.meta.title || 'Portal do Cliente') + ' | Fibra Experts'

  let needAuth = to.matched.some(m => m.meta.auth) // checa se a rota precisa de autenticação
  let isLoggedIn = Auth.isLoggedIn()

  if (to.fullPath.includes('login?personifica')) {
    Vue.http.headers.common['Authorization'] = ''
    localStorage.removeItem('STORAGE.TOKEN')

    next()
    return
  }

  if (to.fullPath.includes('login?personifica')) {
    Vue.http.headers.common['Authorization'] = ''
    localStorage.removeItem('STORAGE.TOKEN')

    next()
    return
  }

  if (needAuth) {
    if (store.state) {
      setTimeout(() => {
        let { nome, email, documento } = store.state
        let { bloco, codigo, empreendimentoIdMega, empreendimentoIdWeb, unidade } = store.state.contratoAtual
        let browser = window.navigator.userAgent

        browser = browser.split('/')
        browser = browser[2]
        browser = browser.split(' ')
        browser = browser[browser.length - 1]

        let obj = {
          url: to.path,
          nomeCliente: nome,
          cpfCliente: documento,
          emailCliente: email,
          codigoCliente: store.state.codigoCliente,
          empreendimentoIdMega,
          empreendimentoIdWeb,
          contrato: codigo,
          bloco,
          unidade,
          browser
        }

        PagesService.insertLog(obj).then(res => {
        }).catch(e => {
          console.error('Falha ao inserir log', e)
        })
      }, 1000)
    }

    if (!isLoggedIn) { // checa se o usuário está autenticado
      next({ path: '/login' })
      return
    }

    next()
  } else {
    next()
  }
})

export default router
